export {storeDispatch} from '../index'

export function mergeState (state, stateToMerge) {
    return Object.assign({}, state, stateToMerge)
}
